import { Box } from "@mui/material";
import { EntityType } from "@common/Common.types.ts";
import { useSystemStepTab } from "./SystemStepTab.hooks.ts";
import { DotLegalFullScreenSpinner } from "@dotlegal/dotlegal-ui-components";
import OverviewStepSection from "@common/components/overviewStepSection/OverviewStepSection.tsx";
import { topPaperMinHeight } from "../SystemOverview.tsx";
import useSystemDisplayFields from "../../systems/systemDisplayFields/SystemDisplayFields.hooks.ts";
import { getFilterIdByEnum } from "../../systems/systemDisplayFields/SystemDisplayFields.types.ts";
import { FieldValue } from "@common/components/overviewStepSection/OverviewStepSection.types.ts";
import { SystemFieldAndGrouping } from "@common/components/filterPopover/FilterPopover.types.ts";
import { useUrlProvider } from "../../../useUrlProvider.ts";

export interface SystemStepTabProps {
    systemId: string;
    stepId: string;
    name: string;
}

function SystemStepTab(props: SystemStepTabProps) {
    const { isLoading, data } = useSystemStepTab(props);
    const { getTableFieldsDictionary, filterIdToEnumMap, isLoading: isFieldsLoading } = useSystemDisplayFields();
    const { getSystemEditUrl } = useUrlProvider();

    if (isFieldsLoading)
        return (
            <Box sx={{ height: topPaperMinHeight }}>
                <DotLegalFullScreenSpinner />
            </Box>
        );

    const dictionary = getTableFieldsDictionary();

    function getFieldDisplayName(fieldValue: FieldValue, dict: Record<string, SystemFieldAndGrouping>): string {
        if (fieldValue.isCustomField && fieldValue.customFieldId) {
            return dict[fieldValue.customFieldId]?.translation || fieldValue.customFieldId;
        }

        if (fieldValue.column !== undefined) {
            const filterId = getFilterIdByEnum(fieldValue.column, filterIdToEnumMap);
            return filterId ? dict[filterId]?.translation || filterId : "";
        }

        return "";
    }

    return (
        <>
            {isLoading ? (
                <Box sx={{ height: topPaperMinHeight }}>
                    <DotLegalFullScreenSpinner />
                </Box>
            ) : (
                <Box sx={{ minHeight: topPaperMinHeight, px: 0.5 }}>
                    <OverviewStepSection
                        step={data!}
                        entityId={props.systemId}
                        entityType={EntityType.System}
                        hideHeader
                        getFieldDisplayName={getFieldDisplayName}
                        dictionary={dictionary}
                        navigateUrl={data?.canNavigate ? getSystemEditUrl(props.systemId, data.stepOrder) : undefined}
                        canNavigate={data?.canNavigate}
                    />
                </Box>
            )}
        </>
    );
}

export default SystemStepTab;
